import script from "./FaqComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqComponent.vue?vue&type=script&setup=true&lang=js"

import "./FaqComponent.vue?vue&type=style&index=0&id=1405160a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1405160a"]])

export default __exports__